<a [routerLink]="['/support-documentation/article', video.slug]" class="support-documentation__video-card">
  <div class="image-wrapper">
    <img [src]="video.video_thumbnail" [alt]="video.title" />
  </div>
  <h3>{{ video.title }}</h3>
</a>
